function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:currentColor}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "\\u30EC\\u30A4\\u30E4\\u30FC_2",
  "data-name": "\\u30EC\\u30A4\\u30E4\\u30FC 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\u30EC\\u30A4\\u30E4\\u30FC_2-2",
  "data-name": "\\u30EC\\u30A4\\u30E4\\u30FC 2"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M26.259 20.816l-.492-4.261-.982.729-2.633-3.546-1.482 1.1 2.634 3.546-.982.729 3.937 1.703zM7.768 20.816l.841-5.959 1.317.977 3.747-5.045 1.988 1.476-3.747 5.045 1.316.978-5.462 2.528zM22.292 10.8a1.589 1.589 0 00-1.2-1.137l-1.885-1.884-2.625-2.625a3.611 3.611 0 00.26-.738 3.534 3.534 0 00.092-.8 3.589 3.589 0 00-1.066-2.556 3.645 3.645 0 00-4.1-.721l1.2 1.2 1.2 1.2-.532 1.3-1.3.532-1.194-1.19-1.193-1.193a3.588 3.588 0 00.771 3.98 3.643 3.643 0 002.574 1.058 3.734 3.734 0 00.73-.073 3.7 3.7 0 00.68-.209l2.647 2.647 1.832 1.832a1.559 1.559 0 00.033.2 1.592 1.592 0 003.076-.824zm-.674.624l-.01.037a.856.856 0 01-.605.605l-.037.01a.856.856 0 01-.827-.221l-.027-.027A.856.856 0 0119.89 11l.01-.037a.857.857 0 01.605-.606l.037-.01a.857.857 0 01.827.222l.027.027a.855.855 0 01.222.828z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-1",
  cx: 6.003,
  cy: 24.57,
  r: 2.823
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M11.714 30.749c0-1.8-2.622-2.937-5.857-2.937S0 28.953 0 30.749c0 .023.005.045.006.068H0V32h11.714v-1.183h-.006c.001-.023.006-.045.006-.068z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  className: "cls-1",
  cx: 26.288,
  cy: 24.57,
  r: 2.823
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M32 30.749c0-1.8-2.622-2.937-5.857-2.937s-5.857 1.141-5.857 2.937c0 .023 0 .045.006.068h-.006V32H32v-1.183h-.006c.006-.023.006-.045.006-.068z"
})), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h32v32H0z"
})));

var SvgJobAllocatemin = function SvgJobAllocatemin(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgJobAllocatemin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/JobAllocate.min.03fe858e.svg";
export { ForwardRef as ReactComponent };